var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "content-hubs-page" } },
    [
      _c(
        "portal",
        { attrs: { to: "ads-container-top" } },
        [
          _c("ci-suggested-external-content", {
            attrs: { type: "display", id: _vm.adIds.header },
          }),
        ],
        1
      ),
      _c(
        "portal",
        { attrs: { to: "ads-container-right" } },
        [
          _c("ci-suggested-external-content", {
            attrs: { type: "skyscraper", id: _vm.adIds.skyscraper },
          }),
          _c("ci-suggested-external-content", {
            attrs: { type: "sidebar", id: _vm.adIds.sidebar_2nd },
          }),
        ],
        1
      ),
      _vm.initialized
        ? [
            _c(
              "div",
              { staticClass: "content-wrapper p-relative d-flex w-100" },
              [
                _c("content-hub-nav-menu"),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-md-flex justify-content-center content-hub--info bg-white w-100",
                  },
                  [
                    !_vm.genericContent
                      ? _c("ci-content-hub")
                      : _c("ci-content-hub-generic"),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.products.length > 0 && !_vm.rootRoute
              ? _c(
                  "div",
                  { staticClass: "content-hub--products m-3 m-md-4 mx-lg-0" },
                  [
                    _c("ci-slider-section-wrapper", {
                      staticClass: "d-print-none mt-xl-4 mx-lg-n4",
                      attrs: {
                        headline: _vm.$t("ui.views.content_hubs.related_fonds"),
                        variants: "transparent",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "slider",
                            fn: function () {
                              return [
                                _c("ci-scroll-snap-slider", {
                                  attrs: {
                                    items: _vm.products,
                                    displayIndicators: false,
                                  },
                                  on: { slideEndReached: _vm.getProducts },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ item, index }) {
                                          return [
                                            _c("ci-product-tile", {
                                              key: item.id,
                                              staticClass: "mb-0",
                                              style: { width: "fit-content" },
                                              attrs: {
                                                product: item,
                                                context: "recommendation",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2205177417
                                  ),
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1443283196
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass:
                  "content-hub--related-content-hubs m-3 m-md-4 mx-lg-0",
              },
              [_c("ci-related-content-hubs")],
              1
            ),
            _vm.articles.length > 0 && !_vm.rootRoute
              ? _c(
                  "div",
                  {
                    staticClass:
                      "content-hub--articles m-3 m-md-4 mx-lg-0 mb-lg-0",
                  },
                  [
                    _c("h5", {
                      staticClass: "h5 mb-2 mb-lg-3",
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("ui.views.content_hubs.related_articles")
                        ),
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "articles" },
                      _vm._l(_vm.articles, function (article, index) {
                        return _c("ci-content-tile", {
                          key: index,
                          staticClass: "w-100",
                          attrs: {
                            "hide-actions": true,
                            "with-hover": true,
                            "tile-data": article,
                          },
                        })
                      }),
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "row justify-content-center align-items-center w-100 mt-4",
                      },
                      [
                        _vm.articlesRemained
                          ? _c("ci-button", {
                              attrs: {
                                label: _vm.$t(
                                  "ui.shared.global.load_more.contents"
                                ),
                                variant: "filled-primary",
                              },
                              on: { click: _vm.getArticles },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }